import {
    AfterViewInit,
    Component,
    EventEmitter,
    Injector,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import { BaseComponent } from '../../../base/base.component';
import { TableComponent } from '../../../ui/table/table.component';
import {
    ConvocationRowItem,
    isConvocationDraft,
} from '../mister-convocation-shared';

@Component({
    selector: 'app-dashboard-mister-convocations-table',
    templateUrl: './convocations-table.component.html',
    styleUrls: ['./convocations-table.component.scss'],
})
export class DashboardMisterConvocationsTableComponent
    extends BaseComponent
    implements AfterViewInit, OnChanges
{
    @ViewChild('convocationsTable') convocationsTable?: TableComponent;

    @Input() convocations: ConvocationRowItem[] = [];
    @Input() loading = false;
    @Input() detailRouteBase: string[] = ['/dashboard/mister/convocations'];
    @Input() showDraftActions = false;
    @Input() statusUpdatingId: string | null = null;

    @Output() approveDraft = new EventEmitter<ConvocationRowItem>();
    @Output() cancelDraft = new EventEmitter<ConvocationRowItem>();

    constructor(public serviceInjector: Injector) {
        super(serviceInjector);
    }

    ngAfterViewInit(): void {
        queueMicrotask(() => this.refreshTable());
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['convocations'] || changes['loading']) {
            this.refreshTable();
        }
    }

    statusBadgeClass(status: string): string {
        const key = status.toLowerCase();
        if (
            key.includes('pubblicat') ||
            key.includes('open') ||
            key.includes('attiv') ||
            key === 'active'
        ) {
            return 'badge-success';
        }
        if (key.includes('bozz') || key.includes('draft')) {
            return 'badge-warning';
        }
        if (
            key.includes('chius') ||
            key.includes('annull') ||
            key.includes('cancell')
        ) {
            return 'badge-unknown';
        }
        return 'badge-warning';
    }

    invitedCount(row: ConvocationRowItem): number | null {
        if (row.users?.length) {
            return row.users.length;
        }
        if (row.invitedCount !== undefined && row.invitedCount > 0) {
            return row.invitedCount;
        }
        return null;
    }

    detailRoute(id: string): string[] {
        return [...this.detailRouteBase, id];
    }

    isDraft(status: string): boolean {
        return isConvocationDraft(status);
    }

    isUpdating(id: string): boolean {
        return this.statusUpdatingId === id;
    }

    private refreshTable(): void {
        if (!this.convocationsTable) {
            return;
        }
        this.convocationsTable.loading = this.loading;
        if (!this.loading) {
            void this.convocationsTable.setData(this.convocations);
        }
    }
}
